<div class="add-first-payment-method skeleton-item overflow-hidden">
  <div class="slide-container">
    <div #slide class="slide scrollbar-hide h-[105px]" (scroll)="onScroll($event)">
      <div
        *ngFor="let method of allowedPaymentMethods; let i = index"
        class="flex-shrink-0 snap-start"
        [ngClass]="numberOfVisibleItems === 1 ? 'w-full' : numberOfVisibleItems === 2 ? 'w-1/2' : 'w-1/3'">
        <div [ngClass]="{ 'border-none': i === allowedPaymentMethods.length - 1 }" tabindex="-1">
          <yat-add-new-payment-method-button
            [id]="'b675f40f-9b3f-41ac-a950-c1c67b2df84c-' + i"
            [paymentMethodType]="method"
            matomoEventClickAction="Submit_FirstPaymentMethod"
            (clickMethod)="addPaymentMethod($event)"
            (focusEvent)="onChildFocus(i)">
          </yat-add-new-payment-method-button>
        </div>
      </div>
    </div>
  </div>
  <button (click)="prevMethod()" [class.hidden]="currentIndex === 0" class="btn-left" tabindex="-1">
    <yat-icon id="ed75192c-1346-4e0c-88f5-56f9f34e4129" name="chevron-left"></yat-icon>
  </button>
  <button (click)="nextMethod()" [class.hidden]="currentIndex >= allowedPaymentMethods.length - 3" class="btn-right" tabindex="-1">
    <yat-icon id="b3686287-c496-4d0f-a031-c4997e46325b" name="chevron-right"></yat-icon>
  </button>
</div>
